import { render, staticRenderFns } from "./DashboardFinanceur.vue?vue&type=template&id=6884452c&scoped=true&"
import script from "./DashboardFinanceur.vue?vue&type=script&lang=js&"
export * from "./DashboardFinanceur.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFinanceur.vue?vue&type=style&index=0&id=6884452c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6884452c",
  null
  
)

export default component.exports